import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ChangePassword() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== confirm) { toast.error("New passwords do not match"); return; }
    if (nw.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed");
      setCur(""); setNw(""); setConfirm("");
      if (refresh) { try { await refresh(); } catch (e) { console.error("Session refresh failed after password change", e); } }
      navigate("/");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div data-testid="module-change-password" className="max-w-md">
      <div className="mb-5 flex items-center gap-2"><KeyRound className="w-6 h-6 text-[#0B132B]" /><div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-head">Change Password</h1>
        <p className="text-sm text-slate-500 mt-0.5">Update your account password</p></div></div>
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-sm p-6 space-y-4">
        <div className="space-y-1"><label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Current Password</label>
          <Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="bg-white" /></div>
        <div className="space-y-1"><label className="text-xs font-semibold uppercase tracking-wider text-slate-500">New Password</label>
          <Input data-testid="cp-new" type="password" value={nw} onChange={(e) => setNw(e.target.value)} required className="bg-white" /></div>
        <div className="space-y-1"><label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Confirm New Password</label>
          <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="bg-white" /></div>
        <Button data-testid="cp-submit" type="submit" disabled={loading} className="bg-[#0B132B] hover:bg-[#1C2541] text-white rounded-sm w-full">{loading ? "Saving..." : "Change Password"}</Button>
      </form>
    </div>
  );
}
